/* Eclipsed — custom Sort dropdown.
   - collection / search pages: progressively enhances Dawn's native
     <select class="facet-filters__sort"> (kept + wired, drives Dawn's AJAX).
   - homepage grid: reads the [data-ecl-sort] mount and reorders the grid
     client-side (the homepage collection object can't honour ?sort_by).
   Both render the same trigger + floating panel. */
(function () {
  'use strict';

  var CHEV =
    '<svg class="ecl-sort__chev" width="11" height="7" viewBox="0 0 11 7" aria-hidden="true" focusable="false"><path d="M1 1l4.5 4.5L10 1" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHECK =
    '<svg class="ecl-sort__check" width="13" height="10" viewBox="0 0 13 10" aria-hidden="true" focusable="false"><path d="M1 5.2l3.6 3.6L12 1.2" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function buildDropdown(opts, getCurrent, onChoose) {
    if (!opts || !opts.length) return null;

    var root = el('div', 'ecl-sort');
    var trigger = el('button', 'ecl-sort__trigger', '<span class="ecl-sort__text">Sort</span>' + CHEV);
    trigger.type = 'button';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var panel = el('div', 'ecl-sort__panel');
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;

    var buttons = opts.map(function (o) {
      var b = el('button', 'ecl-sort__option', CHECK + '<span>' + esc(o.label) + '</span>');
      b.type = 'button';
      b.setAttribute('role', 'option');
      b.dataset.value = o.value;
      b.addEventListener('click', function () {
        onChoose(o.value);
        syncState();
        setOpen(false);
        trigger.focus();
      });
      panel.appendChild(b);
      return b;
    });

    function syncState() {
      var cur = getCurrent();
      buttons.forEach(function (b) {
        var on = b.dataset.value === cur;
        b.classList.toggle('is-selected', on);
        if (on) b.setAttribute('aria-selected', 'true');
        else b.removeAttribute('aria-selected');
      });
    }
    function onDoc(e) { if (!root.contains(e.target)) setOpen(false); }
    function onKey(e) { if (e.key === 'Escape') { setOpen(false); trigger.focus(); } }
    function setOpen(open) {
      if (open) syncState();
      panel.hidden = !open;
      root.classList.toggle('ecl-sort--open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      var m = open ? 'addEventListener' : 'removeEventListener';
      document[m]('pointerdown', onDoc, true);
      document[m]('keydown', onKey, true);
    }

    trigger.addEventListener('click', function () { setOpen(panel.hidden); });

    root.appendChild(trigger);
    root.appendChild(panel);
    syncState();
    return root;
  }

  function enhanceSelect(select) {
    if (!select || select.dataset.eclSortReady === '1') return;
    select.dataset.eclSortReady = '1';

    var opts = Array.prototype.map.call(select.options, function (o) {
      return { value: o.value, label: (o.textContent || '').trim() };
    });
    var dd = buildDropdown(
      opts,
      function () { return select.value; },
      function (v) {
        if (select.value === v) return;
        select.value = v;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    );
    if (!dd) return;
    select.classList.add('ecl-sort__native');
    (select.closest('.facet-filters__field') || select.parentNode).appendChild(dd);
  }

  function initHomeSort(mount) {
    if (!mount || mount.dataset.eclSortReady === '1') return;
    mount.dataset.eclSortReady = '1';

    var section = mount.closest('.shopify-section') || document;
    var grid = section.querySelector('#product-grid') || section.querySelector('.product-grid');
    if (!grid) return;

    Array.prototype.forEach.call(grid.children, function (li, i) {
      if (li.dataset.eclIdx == null) li.dataset.eclIdx = i;
    });

    var opts = Array.prototype.map.call(mount.querySelectorAll('[data-value]'), function (li) {
      return { value: li.getAttribute('data-value'), label: (li.textContent || '').trim() };
    });
    if (!opts.length) return;
    var current = mount.getAttribute('data-default') || opts[0].value;

    function n(li, a) { return parseFloat(li.getAttribute(a)) || 0; }
    function t(li, a) { return (li.getAttribute(a) || '').toLowerCase(); }

    function apply(v) {
      current = v;
      var real = [], holders = [];
      Array.prototype.forEach.call(grid.children, function (li) {
        (li.hasAttribute('data-handle') ? real : holders).push(li);
      });
      var by;
      if (v === 'title-ascending') by = function (a, b) { return t(a, 'data-sort-title').localeCompare(t(b, 'data-sort-title')); };
      else if (v === 'title-descending') by = function (a, b) { return t(b, 'data-sort-title').localeCompare(t(a, 'data-sort-title')); };
      else if (v === 'price-ascending') by = function (a, b) { return n(a, 'data-sort-price') - n(b, 'data-sort-price'); };
      else if (v === 'price-descending') by = function (a, b) { return n(b, 'data-sort-price') - n(a, 'data-sort-price'); };
      else if (v === 'created-ascending') by = function (a, b) { return n(a, 'data-sort-date') - n(b, 'data-sort-date'); };
      else if (v === 'created-descending') by = function (a, b) { return n(b, 'data-sort-date') - n(a, 'data-sort-date'); };
      else by = function (a, b) { return (parseInt(a.dataset.eclIdx, 10) || 0) - (parseInt(b.dataset.eclIdx, 10) || 0); };
      real.sort(by);
      var frag = document.createDocumentFragment();
      real.concat(holders).forEach(function (li) { frag.appendChild(li); });
      grid.appendChild(frag);
    }

    var dd = buildDropdown(opts, function () { return current; }, apply);
    if (!dd) return;
    mount.appendChild(dd);
    mount.classList.add('is-ready');
  }

  function scan(ctx) {
    ctx = (ctx && ctx.querySelectorAll) ? ctx : document;
    Array.prototype.forEach.call(ctx.querySelectorAll('select.facet-filters__sort'), enhanceSelect);
    Array.prototype.forEach.call(ctx.querySelectorAll('[data-ecl-sort]'), initHomeSort);
  }

  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('select.facet-filters__sort')) enhanceSelect(node);
        else if (node.querySelector && (node.querySelector('select.facet-filters__sort') || node.querySelector('[data-ecl-sort]'))) scan(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
